import { useEffect, useRef, useState, useCallback } from "react";

const useScrollToTop = (threshold = 1000, A23TourneyLobby = false) => {
  const scrollContainerRef = useRef(null);
  const [showScrollToTop, setShowScrollToTop] = useState(false);

  useEffect(() => {
    const scrollTarget = scrollContainerRef.current || window;

    const handleScroll = () => {
      const scrollPosition = scrollContainerRef.current
        ? scrollContainerRef.current.scrollTop
        : window.scrollY;

      if (A23TourneyLobby) {
        const targetElement = document.querySelector("#startingLater");
        // const targetElement = document.querySelector("#completedTourneys");
        const targetPosition = targetElement?.getBoundingClientRect();

        const isInViewport = targetPosition
          ? scrollPosition > 1000 && targetPosition.top < window.innerHeight
          : false;
        if (isInViewport) {
          setShowScrollToTop(true);
        } else {
          setShowScrollToTop(false);
        }

        // setShowScrollToTop(isInViewport);
      } else {
        setShowScrollToTop(scrollPosition > threshold);
      }
    };

    scrollTarget.addEventListener("scroll", handleScroll);
    return () => {
      scrollTarget.removeEventListener("scroll", handleScroll);
    };
  }, [threshold, A23TourneyLobby]);

  const scrollToTop = useCallback(() => {
    scrollContainerRef.current?.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return { scrollContainerRef, showScrollToTop, scrollToTop };
};

export default useScrollToTop;
